import {
  CaretUpDownIcon,
  FileIcon,
  GlobeSimpleIcon,
  MicrophoneIcon,
} from "@phosphor-icons/react";
import { useGetLocale } from "@refinedev/core";
import { Select, Space, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { MediaProjectStoryboards } from "../../types";
import { getLanguageName } from "helpers/core/";
import { useProjectNavigate } from "../hooks/useProjectNavigate";

interface InstanceSwitchProps {
  projectDetails: {
    projectId: string;
    storyboardId: string;
    storyboards: MediaProjectStoryboards[];
  };
}

export const InstanceSwitch: React.FC<InstanceSwitchProps> = ({
  projectDetails,
}) => {
  const { navigateToProject } = useProjectNavigate();
  const { theme } = useAntTheme();
  const getLocale = useGetLocale();
  const currentLanguage = getLocale();

  const handleStoryboardChange = (selectedStoryboardId: string) => {
    navigateToProject({
      projectId: projectDetails.projectId,
      storyboardId: selectedStoryboardId,
    });
  };
  const hasMultipleStoryboards =
    projectDetails.storyboards && projectDetails.storyboards.length > 1;
  return (
    <Select
      defaultValue={projectDetails.storyboardId}
      variant="borderless"
      size="large"
      onChange={handleStoryboardChange}
      options={projectDetails.storyboards.map((storyboard) => ({
        label: (
          <Space align="center">
            <>
              <Typography.Text
                strong
                style={{
                  backgroundColor: theme.colorText,
                  color: theme.colorBorderSecondary,
                  borderRadius: 5,
                  padding: "4px 6px",
                  display: "inline-block",
                }}
              >
                {storyboard.language.split("-")[0].toUpperCase()}
              </Typography.Text>
              <Typography.Text strong>
                {currentLanguage &&
                  getLanguageName(storyboard.language, currentLanguage)}
              </Typography.Text>
            </>
            {storyboard.storyboard_generation_mode === "Translate" && (
              <GlobeSimpleIcon
                size={24}
                style={{ verticalAlign: "text-top", marginLeft: 4 }}
              />
            )}
            {storyboard.storyboard_generation_mode === "Transcript" && (
              <div style={{ position: "relative", marginLeft: 4 }}>
                <FileIcon size={24} style={{ verticalAlign: "text-top" }} />
                <MicrophoneIcon
                  size={16}
                  weight="bold"
                  style={{
                    verticalAlign: "text-top",
                    position: "absolute",
                    bottom: 2,
                    right: 0,
                    backgroundColor: theme.colorBgContainer,
                  }}
                />
              </div>
            )}
          </Space>
        ),
        value: storyboard.id,
      }))}
      suffixIcon={
        hasMultipleStoryboards ? (
          <CaretUpDownIcon size={24} weight="bold" />
        ) : null
      }
      style={{
        // width: 220,
        ...(hasMultipleStoryboards ? {} : { pointerEvents: "none" }),
      }}
    />
  );
};
